<template lang='pug'>
  i.svg-icon.svg-icon-location
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100')

      path(d='M50.24,6.65c15.01,0.16,27.58,11.38,29.5,26.34c0.84,6.55-0.33,12.68-3.46,18.44c-7.04,12.96-14.15,25.89-21.2,38.85 c-1.09,2-2.62,3.25-4.94,3.22c-2.25-0.03-3.74-1.24-4.8-3.18c-7.08-13.01-14.27-25.96-21.27-39.01 c-9.69-18.06,0.45-39.73,20.48-43.95C46.42,6.98,48.34,6.88,50.24,6.65z M50.21,21.71c-6.67,0-12.18,5.48-12.2,12.14 c-0.02,6.68,5.45,12.21,12.1,12.24c6.75,0.04,12.3-5.49,12.29-12.23C62.38,27.2,56.88,21.71,50.21,21.71z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};

</script>
